/**
 * Kill switch feature gate. When off, the launcher renders nothing and the TAP
 * traits are never fetched.
 */
export const KILL_SWITCH = 'rovo_reintroduction_modal';

/**
 * TAP (Traits And Personalization) user-level trait: truthy when the user HAS
 * sent at least one Rovo chat message.
 */
export const TRAIT_HAS_SENT_ROVO_CHAT_MESSAGE = 'segment_has_sent_rovo_chat_message_aaid';

/**
 * TAP user-level trait: truthy when the user is a Rovo chat monthly active user
 * (i.e. NOT dormant).
 */
export const TRAIT_IS_ROVO_CHAT_MAU = 'is_rovo_chat_mau';

/**
 * TAP site-scoped trait holding the date the user first became active in Jira.
 * Used to detect first-time users who are covered by a separate onboarding
 * experience, so the reintroduction modal does not double up on them.
 */
export const TRAIT_JIRA_FIRST_ACTIVE = 'jira-software_first_active';

/**
 * TAP site-scoped trait holding the date the user first became active in
 * Confluence. See {@link TRAIT_JIRA_FIRST_ACTIVE}.
 */
export const TRAIT_CONFLUENCE_FIRST_ACTIVE = 'confluence_first_active';

/**
 * A user whose product activation date is within this many days is treated as a
 * first-time user and excluded from the reintroduction modal (they get the
 * dedicated onboarding experience during this window instead). Set toward the
 * conservative end of the typical 14–30 day range so the modal stays out of the
 * way until onboarding is well finished.
 */
export const FIRST_TIME_USER_DAYS = 30;

/**
 * Upper bound on how long we wait for the TAP traits fetch before giving up. If
 * TAP is slow or unavailable we treat the user as not eligible rather than
 * blocking on the request — the modal simply does not show this session.
 */
export const TRAITS_FETCH_TIMEOUT_MS = 3000;

/**
 * Growth initiative used to attribute the modal's analytics events.
 * TODO: confirm the owning team's growth initiative before rollout.
 */
export const GROWTH_INITIATIVE = 'ai-mate';

/**
 * localStorage key used to ensure the modal is shown at most once per browser.
 */
export const DISMISSED_STORAGE_KEY = 'rovo-reintroduction-modal.dismissed';

/** Source tag attached to the rovo-triggers `chat-new` event. */
export const CHAT_OPEN_SOURCE = 'rovo-reintroduction-modal';
